import * as THREE from 'three';
const { degToRad } = THREE.MathUtils;
import { CommonModule } from "@angular/common";
import { Component, Input } from "@angular/core";
import { FormsModule } from "@angular/forms";
import { SahneWtecKafa } from "./SahneWtecKafa";
import { FikoYTKokBilesenComponent } from "@/src/service/kok-bilesen/kok-bilesen.component";
import { FikoGrupCizim } from "../../IFikoThreeJS/FikoGrupCizim";
import { FikoSahne } from "../../IFikoThreeJS/FikoSahne";
import { FikoIsikOrtam } from "../../IFikoThreeJS/FikoIsikOrtam";
import { FikoIsikYonsel } from "../../IFikoThreeJS/FikoIsikYonsel";
import { FikoImporterWRL } from "../../IFikoThreeJS/FikoImporter.WRL";
import { FikoCizimYalin } from "../../IFikoThreeJS/FikoCizimYalin";
import { FikoVektor3D } from "../../IFikoThreeJS/FikoVektor3d";


@Component({
    selector: 'fikoyt-b-acisi-3d-ek-bilesen',
    template: `
     <div style="background-color: transparent;color: white;max-width:100%;">
        <div style="display: flex;align-items: center;justify-content: center;">
                <div style="display: flex;flex-direction: column;max-width: 500px;">
                            <div>
                                <div style="color:yellow;">
                                    Açıklama :
                                </div>
                                <div> Eğer B Açısı Ve C Açısı Sıfırda İken 3D Görüntüdeki Gibi Gözükmüyorsa Alttaki Kutucuktan Gerekli Ayarlamaları Yapabilirsiniz. </div>
                            </div>

                            <span style="flex:0;">
                                <div style="display: flex;align-items:center;">
                                    <span style="color:yellow;">
                                    Kalibre Açısı :
                                    </span>
                                    <input [(ngModel)]="element.kalibrasyon" (ngModelChange)="aciDegisti();" class="fikoinput" type="number" placeholder="Seç" size="1" style="flex:1;">
                                </div>
                            </span>
                            
                            <div style="color:yellow;">
                                    Açı Artım Yönü :
                            </div>
                            <div> B Açısını Çevirdiğinizde Saat Yönündemi Yoksa Tersi Yöndemi Artıyor.Bunu Aşağıdaki Kutucuktan Belirleyebilirsiniz </div>
                            <select [(ngModel)]="element.yon" (ngModelChange)="aciDegisti();" style="margin-bottom:0.5em;">
                                <option value="1">Saat Yönünün Tersi</option>
                                <option value="2">Saat Yönünde</option>
                            </select>
                            <div style="color:yellow;">
                                    B Açısı : {{ element.aci }}゜
                            </div>
                            <div> B Açısını Aşağıdaki Kaydırma Çubuğundanda Ayarlayabilirsiniz </div>
                            <div>
                                <input type="range" [min]="element.userData?.FikoParametreler?.[0].ayar?.min ? element.userData?.FikoParametreler?.[0].ayar?.min:0"
                                    [max]="element.userData?.FikoParametreler?.[0].ayar?.maks ? element.userData?.FikoParametreler?.[0].ayar?.maks:100" tabindex="0" [ngModel]="element.userData?.FikoParametreler?.[0].degeri"
                                    [step]="element.userData?.FikoParametreler?.[0].ayar?.adim ? element.userData?.FikoParametreler?.[0].ayar?.adim:1"
                                    (ngModelChange)="element.userData?.FikoParametreler?.[0].degisti ? element.userData?.FikoParametreler?.[0].degisti($event):null;element.userData && element.userData.FikoParametreler && (element.userData.FikoParametreler[0].degeri=$event);CD.detectChanges();FikoYT.degisti.emit();"
                                    style="width: 100%;margin-top: 0.5rem;pointer-events: all;" />
                            </div>
                        </div>
            </div>
    </div>
    `,
    styleUrl: '../.component3D.scss',
    imports: [
        CommonModule,
        FormsModule,
    ]
})
export class FikoBAcisiEkBilesen extends FikoYTKokBilesenComponent {
    @Input() element;

    constructor() {
        super();
        this.subsList.push(this.FikoYT.degisti.subscribe(() => {
            this.CD.detectChanges();
        }))
    }

    override ngAfterViewInit() {
        super.ngAfterViewInit();

    }


    ngOnInit(): void {

    }


    aciDegisti() {
        this.element.userData['FikoParametreler'][0].degisti(this.element.userData['FikoParametreler'][0].degeri);
        // PERFORMANS: Emit yerine direkt ciz() kullan
        this.element?.sahne.anaGosterim.ciz();
    }

    ngOnDestroy(): void {
        super.ngOnDestroy();
    }
}


export class BAcisiUst extends FikoGrupCizim {
    override type: any = "BAcisiUst";
    /** */
    sayac = 1;

    /** */
    hizli3DMenu = [
        {
            simgeYazi: "👁‍🗨",
            baslik: "Gizle / Göster",
            renkSinif: "yellow",
            tiklandi: () => {
                this.visible = !this.visible;
                this.sahne.anaGosterim.FikoYT.degisti.emit();
            }
        },
    ]
    hizliMenu3DEk = FikoBAcisiEkBilesen;
    hizliMenu3DEkParametreler: { element: any } = { element: this };
    /** */
    aciMesh = null;
    aci: number = 0;
    kalibrasyon: number = -90;
    yon: "1" | "2" = "1";

    // PERFORMANS: Cached değerler - her frame yeniden hesaplama yok
    private _lastAci: number = 0;
    private _lastKalibrasyon: number = -90;
    private _lastYon: "1" | "2" = "1";
    private readonly _tempAxis = new FikoVektor3D(0, 0, 1);

    public override get liste(): FikoIsikOrtam[] | FikoIsikYonsel[] {
        return this.children as any;
    }

    constructor(public override sahne?: FikoSahne & SahneWtecKafa, name?: string) {
        super(sahne);

        const importer = new FikoImporterWRL(this.sahne);
        importer.alUrlden("./assets/3D/WTEC-KAFA/B-UST-ACI.FikoCizim").then((_rslt: { yuzeyler: THREE.BufferGeometry<THREE.NormalBufferAttributes>, cizgiler: any, vertex: any }[]) => {
            for (let i = 0; i < _rslt.length; i++) {
                const e = _rslt[i];
                // e.yuzeyler.translate(-0.137, 4.964, 0);
                this.aciMesh = new FikoCizimYalin(this.sahne, name ?? "B Açısı(Üst)", e.yuzeyler, e.cizgiler, e.vertex);
                this.aciMesh.name += "." + (i + 1)
                this.aciMesh.userData['FikoArayuz'].agactaGorunur = false;
                this.aciMesh.userData['FikoArayuz'].listeGoster = false;
                this.ekle(this.aciMesh);
            }
        })
        // this.setRotationFromAxisAngle(new FikoVektor3D(0, 0, 1), degToRad(270));
        this.name = name;
        this.userData['FikoArayuz'].agactaGorunur = true;
        this.userData['FikoArayuz'].listeGoster = true;
        this.userData['FikoArayuz'].simge = "./simgeler/kurdela.webp";
        // /** */
        // let q = new THREE.Quaternion().setFromAxisAngle(new FikoVektor3D(0, 0, 1), degToRad(0));
        // this.applyQuaternion(q);
        // // tutucuDonerKafa.setRotationFromAxisAngle(new FikoVektor3D(0, 0, 1.0), degToRad(0))
        // this.userData.oldMatrix = this.matrix.clone();
        if (this.yon == "1") {
            this.setRotationFromAxisAngle(new FikoVektor3D(0, 0, 1), degToRad((this.kalibrasyon + this.aci) + 0.5));
        } else if (this.yon == "2") {
            this.setRotationFromAxisAngle(new FikoVektor3D(0, 0, 1), degToRad((this.kalibrasyon + (360 - this.aci)) + 0.5));
        }

        this.userData['FikoParametreler'] = [
            {
                turu: "Çubuk",
                ayar: {
                    min: 0,
                    maks: 360,
                    adim: 0.1
                },
                degeri: this.aci,
                degisti: (dgr?) => {
                    // İlk çağrıda dgr undefined olabilir, o zaman mevcut aci değerini kullan
                    if (dgr === undefined) {
                        dgr = this.aci;
                    }

                    // PERFORMANS: Sadece değişiklik varsa hesapla
                    if (dgr === this._lastAci && this.yon === this._lastYon && this.kalibrasyon === this._lastKalibrasyon) {
                        return;
                    }

                    this.aci = dgr;
                    this._lastAci = dgr;
                    this._lastYon = this.yon;
                    this._lastKalibrasyon = this.kalibrasyon;

                    // PERFORMANS: Inline hesaplama - ara değişken yok
                    const rotationAngle = this.yon === "1"
                        ? degToRad((this.kalibrasyon + this.aci) + 0.5)
                        : degToRad((this.kalibrasyon + (360 - this.aci)) + 0.5);

                    // PERFORMANS: Tek setRotation çağrısı - reusable axis vektörü
                    this.setRotationFromAxisAngle(this._tempAxis, rotationAngle);

                    // PERFORMANS KRİTİK: Emit kaldırıldı - sadece animasyon sırasında RAF loop emit eder
                }
            }
        ];
    }


    override raycast(raycaster: THREE.Raycaster, intersects: THREE.Intersection[] | any): void {
        // PERFORMANS KRİTİK: Sadece kendi aciMesh'ini yakala - diğer açıların mesh'lerini değil
        if (!this.visible || !this.aciMesh) return;

        const kesisenler = raycaster.intersectObject(this.aciMesh, true);
        if (kesisenler.length === 0) return;

        // PERFORMANS: İlk kesişimi direkt kullan
        const firstHit = kesisenler[0];
        intersects.push({
            object: this,
            distance: firstHit.distance,
            point: firstHit.point,
            face: firstHit.face,
            faceIndex: firstHit.faceIndex,
            index: firstHit.index,
            //@ts-ignore
            instanceId: this.id,
            //@ts-ignore
            altObje: firstHit.object,
            //@ts-ignore
            grup: this,
            //@ts-ignore
            enUstte: false,
            //@ts-ignore
            secilebilir: true,
            //@ts-ignore
            hizli3DMenu: this.hizli3DMenu,
            //@ts-ignore
            hizliMenu3DEk: this.hizliMenu3DEk,
            //@ts-ignore
            hizliMenu3DEkParametreler: this.hizliMenu3DEkParametreler
        } as any);
    }
}